module.exports = __webpack_public_path__ + "static/ecommerce-e83205d89522889c1eb927768b8ca735.png";